export * from "../../original/js/components/closable"

// soon to be depricated.
import { Closable } from '../../original/js/components/closable';

export default Closable
